/**
 * Sign In Page
 */

import { SignIn } from '@clerk/clerk-react';
import { createFileRoute } from '@tanstack/react-router';

interface SignInSearch {
  redirect?: string;
}

export const Route = createFileRoute('/_auth/sign-in')({
  validateSearch: (search: Record<string, unknown>): SignInSearch => {
    return {
      redirect: typeof search.redirect === 'string' ? search.redirect : undefined,
    };
  },
  component: SignInPage,
});

function SignInPage() {
  const { redirect } = Route.useSearch();

  return (
    <SignIn
      routing="hash"
      signUpUrl="/sign-up"
      forceRedirectUrl={redirect || '/'}
    />
  );
}
